import styled from "styled-components";
import { STYLES } from "../../Constant/Theme";


export const PopularCourseContent = styled.div`
  width: 100%;
  height: 100%;
  min-width: 520px;
  @media only screen and (max-width: 900px) {
    width: 100%;
    min-width: 100%;
  }
`;
export const PopularCourse = styled.div`
  box-sizing: border-box;
  width: 90%;
  /* height: 25%; */
  min-width: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  @media only screen and (max-width: 900px) {
    width: 99%;
  }
`;
export const EachPopularCourse = styled.div`
  ${STYLES.VerticalLeftAlign};
  box-sizing: border-box;
  width: 100%;
  height: 150px;
  margin-top: 10px;
  padding-top: 10px;
  align-items: flex-start;
  /* background-color: red; */
  @media only screen and (max-width: 600px) {
  /* flex-direction:column ; */
  }
`;

export const EachBlog = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  margin-left: 10px;
  height: 100%;
  padding-top: 5px;
  padding-bottom: 5px;
  @media only screen and (max-width: 900px) {
  }
`;
export const BackIcon = styled.span`
margin-right: 10px;
cursor: pointer;
`;
